/* sp-review-cards — kendi vanilla slider'ımız: translateX + sürükleme + nokta/ok; metin yok (aria metinleri Liquid'den). */
(function () {
  'use strict';
  var EASE = 'transform 400ms cubic-bezier(0.25, 1, 0.5, 1)';

  function SpReviewSlider(root) {
    this.root = root;
    this.track = root.querySelector('[data-sp-rc-track]');
    this.list = root.querySelector('[data-sp-rc-list]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-rc-slide]'));
    this.prev = root.querySelector('[data-sp-rc-prev]');
    this.next = root.querySelector('[data-sp-rc-next]');
    this.dotsWrap = root.querySelector('[data-sp-rc-dots]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-sp-rc-dot]'));
    this.adaptive = root.getAttribute('data-adaptive') === 'true';
    this.dragEnabled = root.getAttribute('data-drag') !== 'false';
    this.index = 0;
    this.perView = 1;
    this.step = 0;
    this.drag = null;
    if (!this.track || !this.list || !this.slides.length) return;
    root.setAttribute('data-sp-rc-ready', '');
    root.spSlider = this;
    this.bind();
    this.measure();
    this.goTo(0, false);
    root.classList.add('sp-rc--ready');
  }

  SpReviewSlider.prototype.bind = function () {
    var self = this;
    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1, true); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1, true); });
    this.dots.forEach(function (d) {
      d.addEventListener('click', function () { self.goTo(parseInt(d.getAttribute('data-sp-rc-dot'), 10) || 0, true); });
    });
    if (this.dragEnabled && window.PointerEvent) {
      this.track.addEventListener('pointerdown', function (e) { self.onDown(e); });
      this.track.addEventListener('pointermove', function (e) { self.onMove(e); });
      this.track.addEventListener('pointerup', function (e) { self.onUp(e); });
      this.track.addEventListener('pointercancel', function (e) { self.onUp(e, true); });
      this.track.addEventListener('click', function (e) { if (self.moved) { e.preventDefault(); e.stopPropagation(); self.moved = false; } }, true);
      this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { self.goTo(self.index - 1, true); }
      else if (e.key === 'ArrowRight') { self.goTo(self.index + 1, true); }
    });
    var raf = null;
    var onResize = function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { self.measure(); self.goTo(self.index, false); });
    };
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(onResize);
      ro.observe(this.track);
      this.slides.forEach(function (s) { ro.observe(s); });
    } else {
      window.addEventListener('resize', onResize);
    }
    this.list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', onResize, { once: true });
    });
  };

  SpReviewSlider.prototype.measure = function () {
    var cs = getComputedStyle(this.root);
    var n = parseFloat(cs.getPropertyValue('--sp-rc-n')) || 1;
    var gap = parseFloat(cs.getPropertyValue('--sp-rc-gap')) || 0;
    this.perView = Math.max(1, Math.round(n));
    var w = this.slides[0].getBoundingClientRect().width;
    this.step = w + gap;
    this.maxIndex = Math.max(0, this.slides.length - this.perView);
    this.slides.forEach(function (s) { s.style.minHeight = ''; });
    this.heights = this.slides.map(function (s) { return s.getBoundingClientRect().height; });
  };

  SpReviewSlider.prototype.goTo = function (i, animate) {
    var idx = Math.min(Math.max(0, i), this.maxIndex);
    this.index = idx;
    this.list.style.transition = animate ? EASE : 'none';
    this.list.style.transform = 'translate3d(' + (-idx * this.step) + 'px, 0, 0)';
    this.update();
  };

  SpReviewSlider.prototype.update = function () {
    var self = this;
    if (this.prev) this.prev.disabled = this.index <= 0;
    if (this.next) this.next.disabled = this.index >= this.maxIndex;
    if (this.dotsWrap) this.dotsWrap.hidden = this.maxIndex < 1;
    this.dots.forEach(function (d, k) {
      var li = d.parentElement;
      if (li) li.hidden = k > self.maxIndex;
      var active = k === self.index;
      d.classList.toggle('is-active', active);
      // tablist/tab rolleri kaldırıldı (ul>li yapısı aria-required-children'ı bozuyordu); aktiflik aria-current ile
      if (active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    this.slides.forEach(function (s, k) {
      var visible = k >= self.index && k < self.index + self.perView;
      s.classList.toggle('is-active', k === self.index);
      s.classList.toggle('is-visible', visible);
      s.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
    if (this.adaptive && this.perView === 1 && this.heights) {
      var h = this.heights[this.index];
      if (h) {
        this.track.style.height = h + 'px';
        this.slides.forEach(function (s) { s.style.minHeight = h + 'px'; });
      }
    } else {
      this.track.style.height = '';
      this.slides.forEach(function (s) { s.style.minHeight = ''; });
    }
  };

  SpReviewSlider.prototype.onDown = function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (this.maxIndex < 1) return;
    this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), base: -this.index * this.step, dx: 0, locked: null };
    this.moved = false;
    try { this.track.setPointerCapture(e.pointerId); } catch (err) { /* yok say */ }
  };

  SpReviewSlider.prototype.onMove = function (e) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x, dy = e.clientY - d.y;
    if (d.locked === null) {
      if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
      d.locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (d.locked === 'x') this.root.classList.add('sp-rc--dragging');
    }
    if (d.locked !== 'x') return;
    d.dx = dx;
    this.moved = true;
    if (e.cancelable) e.preventDefault();
    this.list.style.transition = 'none';
    this.list.style.transform = 'translate3d(' + (d.base + dx) + 'px, 0, 0)';
  };

  SpReviewSlider.prototype.onUp = function (e, cancelled) {
    var d = this.drag;
    if (!d || e.pointerId !== d.id) return;
    this.drag = null;
    this.root.classList.remove('sp-rc--dragging');
    try { this.track.releasePointerCapture(e.pointerId); } catch (err) { /* yok say */ }
    if (cancelled || d.locked !== 'x') { this.goTo(this.index, true); return; }
    var dt = Math.max(1, Date.now() - d.t);
    var v = Math.abs(d.dx) / dt;
    var target = this.index;
    if (Math.abs(d.dx) > this.step * 0.3 || (Math.abs(d.dx) > 20 && v > 0.5)) target = this.index - (d.dx > 0 ? 1 : -1);
    this.goTo(target, true);
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sp-rc-slider]:not([data-sp-rc-ready])');
    Array.prototype.forEach.call(nodes, function (el) { new SpReviewSlider(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target && e.target.closest ? e.target.closest('[data-sp-rc-slider]') : null;
    if (!slider || !slider.spSlider) return;
    var idx = slider.spSlider.slides.indexOf(e.target.closest('[data-sp-rc-slide]'));
    if (idx >= 0) slider.spSlider.goTo(Math.min(idx, slider.spSlider.maxIndex), true);
  });
})();
